/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Drag_Drop_TitleInputs */



/**
* | output |
* | --- |
* | "Drop files to upload" |
*
* @param {Chat_Drag_Drop_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_drag_drop_title = /** @type {((inputs?: Chat_Drag_Drop_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Drag_Drop_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien hier ablegen, um sie hochzuladen")
	return /** @type {LocalizedString} */ ("Drop files to upload")
});